// src/services/aiApiService.js

import { apiRequest } from "./apiService";
import { API_TIMEOUTS } from "./apiTimeouts";

/**
 * Use this for AI-backed endpoints only.
 *
 * Keeps normal APIs fast while giving AI calls enough time.
 */
export const aiApiRequest = (
  endpoint,
  method = "POST",
  body = null,
  opts = {}
) => {
  return apiRequest(endpoint, method, body, {
    ...opts,
    timeoutMs: opts.timeoutMs ?? API_TIMEOUTS.ai,
  });
};

export const longAiApiRequest = (
  endpoint,
  method = "POST",
  body = null,
  opts = {}
) => {
  return apiRequest(endpoint, method, body, {
    ...opts,
    timeoutMs: opts.timeoutMs ?? API_TIMEOUTS.aiLong,
  });
};